"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateApiContracts = void 0;
const core_1 = require("@ts-rest/core");
const auth_1 = require("./auth");
const jobs_1 = require("./jobs");
const offers_1 = require("./offers");
const profile_1 = require("./profile");
const settings_1 = require("./settings");
const c = (0, core_1.initContract)();
exports.CandidateApiContracts = c.router({
    auth: auth_1.CandidateAuthContract,
    jobs: jobs_1.CandidateJobsContract,
    offers: offers_1.CandidateJobOffersContract,
    profile: profile_1.CandidateProfileContract,
    settings: settings_1.CandidateAccountSettingsContract,
}, { pathPrefix: '/api/candidate' });
__exportStar(require("./auth"), exports);
__exportStar(require("./jobs"), exports);
__exportStar(require("./offers"), exports);
__exportStar(require("./profile"), exports);
__exportStar(require("./settings"), exports);
